import { Injectable } from "@angular/core";
import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http'
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private _toastr: ToastrService, private _service: ApiService, private route: Router, private translateService: TranslateService) {
        translateService.get(["INTERCEPTOR"]).subscribe((values) => {
            this.enJsonData = Object.keys(values).map(key => values[key]);
            // console.log(this.enJsonData);
        }
        );
    }
    enJsonData: any
    isRefreshApiCalled: boolean = false;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            let urltype = this.route.url;
            if (err.status === 401) {
                if (urltype != '/') {
                    localStorage.clear();
                    window.location.href = '/';
                    this._toastr.error('', this.enJsonData[0]['SESSIONTIMEOUT']);
                }
                // else {
                //     this._toastr.error('', this.enJsonData[0]['INCORRECTDETAILS'])
                // }
                if (err.error.status.message != this.enJsonData[0]['USER_SESSION_EXPIRY']) {
                    if (!this.isRefreshApiCalled) {
                        this.isRefreshApiCalled = true;
                    }
                }
                // else {
                // }
            } else {
                if (err.error?.status?.msgCode == this.enJsonData[0]['USERNOTFOUND']) {
                    this._toastr.error('', err.error?.status?.message)
                }
            }


            return throwError(err);
        }))
    }
}